export default "__VITE_ASSET__BRL48dpM__"